import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

// Harga tampilan untuk landing page (tagihan tetap memakai harga di database)
const DISPLAY_PRICE = { 10: 0, 11: 17000 };
// Harga asli sebelum diskon 90% (coret)
const ORIGINAL_PRICE = { 10: 17000, 11: 170000 };

const PACKAGES = [
  {
    id: 10,
    name: 'Independence',
    badge: 'Paket Basic',
    price: DISPLAY_PRICE[10],
    originalPrice: ORIGINAL_PRICE[10],
    tagline: 'Langkah pertama menuju kemerdekaan finansial Anda.',
    features: [
      'Handout & materi pendukung',
      'Kuis & evaluasi pemahaman',
    ],
    highlight: false,
  },
  {
    id: 11,
    name: 'Independence Plus+',
    badge: 'Paket Lengkap',
    price: DISPLAY_PRICE[11],
    originalPrice: ORIGINAL_PRICE[11],
    tagline: 'Paket lengkap untuk memproklamirkan kemerdekaan finansial Anda.',
    features: [
      'Semua fitur Paket Basic',
      'Video',
      'Transkrip lengkap setiap sesi',
      'Excel Siap Pakai',
      'Prioritas support & komunitas',
    ],
    highlight: true,
  },
];

function Bunting() {
  const colors = ['#CE1126', '#fff', '#CE1126', '#fff'];
  return (
    <div className="d-flex justify-content-center" style={{ overflow: 'hidden', lineHeight: 0 }}>
      {Array.from({ length: 24 }).map((_, i) => (
        <div
          key={i}
          style={{
            width: 0,
            height: 0,
            borderLeft: '16px solid transparent',
            borderRight: '16px solid transparent',
            borderTop: `24px solid ${colors[i % 4]}`,
            margin: '0 1px',
          }}
        />
      ))}
    </div>
  );
}

function Spesial17() {
  const navigate = useNavigate();
  const [kelas, setKelas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchKelas = async () => {
      try {
        const response = await api.get(`/api/webinars`);
        setKelas(response.data);
      } catch (err) {
        setError('Gagal memuat daftar kelas.');
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchKelas();
  }, []);

  const choosePackage = (id) => {
    if (String(id) === '10') {
      // Gratis — langsung download tanpa form (relative agar tercatat di page-traffic host yang aktif)
      window.location.href = '/materi/9/download';
      return;
    }
    // Berbayar — pindah ke halaman form terpisah agar tidak robet
    navigate(`/promo-merdeka/daftar?paket=${id}`);
  };

  const formatRupiah = (number) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(number);
  };

  return (
    <div className="bg-light">
      {/* Video promosi */}
      <div className="container my-4">
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/5N_eoTltfB8?si=J37H53ooaS3wUwu5"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      {/* PAKET */}
      <section id="paket" className="container py-5">
        <div className="text-center mb-5">
          <p className="fw-semibold text-danger mb-0">
            <i className="bi bi-fire me-1"></i>
            Promo berakhir pada 31 Agustus · Hanya tersisa 150 slot promo
          </p>
        </div>

        {loading ? (
          <div className="text-center py-4">Memuat paket...</div>
        ) : error ? (
          <div className="text-center py-4" style={{ color: 'red' }}>{error}</div>
        ) : (
          <div className="row g-4 justify-content-center">
            {PACKAGES.map(pkg => {
              return (
                <div key={pkg.id} className="col-md-6 col-lg-5">
                  <div className={`card h-100 shadow-sm ${pkg.highlight ? 'neon-card' : ''}`}>
                    {pkg.highlight && (
                      <div className="position-absolute top-0 start-50 translate-middle" style={{ zIndex: 2 }}>
                        <span className="badge text-bg-warning px-3 py-2">Paling Laris</span>
                      </div>
                    )}
                    <div className="card-body p-4 text-center">
                      <h5 className="text-uppercase text-muted fw-semibold">{pkg.badge}</h5>
                      <h3 className={`fw-bold mb-1 ${pkg.highlight ? 'gold-text' : ''}`}>{pkg.name}</h3>
                      <p className="text-muted">{pkg.tagline}</p>
                      <div className="mb-3">
                        {pkg.price > 0 ? (
                          <>
                            <div className="mb-1">
                              <span className="text-muted" style={{ textDecoration: 'line-through', fontSize: '1.05rem' }}>
                                {formatRupiah(pkg.originalPrice)}
                              </span>
                              <span className="badge text-bg-danger ms-2">-90%</span>
                            </div>
                            <span className="display-5 fw-bold" style={{ color: '#F68D6E' }}>
                              {formatRupiah(pkg.price)}
                            </span>
                          </>
                        ) : (
                          <div>
                            <span className="display-5 fw-bold text-success">GRATIS</span>
                            <div className="text-muted">Rp 0 — langsung terdaftar, tanpa pembayaran</div>
                          </div>
                        )}
                      </div>
                      <ul className="list-unstyled text-start mb-4">
                        {pkg.features.map((f, i) => (
                          <li key={i} className="py-1">
                            <i className="bi bi-check-circle-fill me-2" style={{ color: '#198754' }}></i>
                            {f}
                          </li>
                        ))}
                      </ul>
                      <button
                        className={`btn ${pkg.highlight ? 'btn-warning' : 'btn-outline-secondary'} w-100`}
                        onClick={() => choosePackage(pkg.id)}
                      >
                        Pilih {pkg.name}
                      </button>
                    </div>
                    {pkg.highlight && <div className="neon-shine" aria-hidden="true" />}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}

export default Spesial17;
